module.exports = __webpack_public_path__ + "media/images/consultorio2-c3724bb2f1ca707d9c7ffa27e688c4fa.svg";